<script>
    import { network, store } from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import { Link, navigate } from 'svelte-routing';
    import { onMount } from 'svelte';
    import KontrSelectSearch from "../components/KontrSelectSearch.svelte";
    import ManagerSelectSearch from "../components/ManagerSelectSearch.svelte";
    import NewClientModal from '../components/NewClientModal.svelte';
    import NewContactModal from '../components/NewContactModal.svelte';
    import NewProjModal from '../components/NewProjModal.svelte';


    const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);

    const toArray = (data) => {
        if (!data) return [];
        return Array.isArray(data) ? data : [data];
    };

    const fetchtipTasks = async () => await network.getMaterial();
    let tipTasks = fetchtipTasks();

    const fetchprojs = async (kontr) => await network.getProj({
        idKontr: kontr
    });


    let tipTask = '';
    let vidTask = '';
    let problem = '';
    let deadline = '';
    let proj = '';

    let idKontr = 0;
    let selectedKontakt = null;

    let selectedManagers = [];
    let managerOpen = false;

    let isSubmitting = false;
    let submitSummary = false;
    let formError = '';
    let fieldErrors = {};

    let showNewClientModal = false;
    let showNewProjModal = false;
    let showNewContactModal = false;
    let pendingClient = null;

    const loadClients = async () => {
        const result = await network.fetch_proxy(`EXEC getUrlica @svoi = 0, @idSklad = 0`);
        return toArray(result);
    };

    let clientsPromise = loadClients();

    // Стабильный список клиентов — обновляется только при реальном изменении данных
    let clientList = [];
    $: clientsPromise.then(data => {
        const baseList = toArray(data).map(({ idUrllico, name }) => ({ idUrllico, name }));
        clientList = pendingClient && !baseList.some(c => +c.idUrllico === +pendingClient.idUrllico)
            ? [...baseList, pendingClient]
            : baseList;
    });

    // Стабильный список менеджеров — грузим один раз, а не в {#await} шаблона
    let managerList = [];
    let managersLoading = true;
    const loadManagers = async () => {
        try {
            const data = await network.fetch_proxy(`EXEC getSotrud @svoi = 1, @idSklad = 0`);
            managerList = toArray(data).filter(item => item?.name).map(({ id, name, tel }) => ({ id, name, tel }));
        } finally {
            managersLoading = false;
        }
    };
    loadManagers();

    let tipTaskRef;
    let problemRef;
    let deadlineInput;
    let clientRef;
    let managerRef;
    let contactRef;
    let vidTaskRef;
let projRef;

    const MAX_PROBLEM_LENGTH = 500;

    const fieldLabels = {
        projRef: 'Проект',
        tipTask: 'Тип задачи',
        vidTask: 'Вид задачи',
        problem: 'Описание задачи',
        deadline: 'Срок до',
        client: 'Клиент',
        manager: 'Менеджер',
        contact: 'Контакт'
    };

    onMount(async () => {
        if ($user?.id && $user?.name) {
            selectedManagers = [{ id: +$user.id, name: $user.name }];
        }
    });

    $: filledCount = [tipTask, problem.trim(), deadline, idKontr, selectedManagers.length].filter(Boolean).length;
    $: progress = Math.round((filledCount / 5) * 100);

    $: kontaktsPromise = idKontr
        ? network.fetch_proxy(`EXEC getKontakts @idKontr = ${+idKontr}`)
        : Promise.resolve([]);

    $: if (idKontr) selectedKontakt = null;

    // Загружаем проекты при выборе клиента (idKontr).
    // projsRefresh позволяет принудительно перезагрузить список (например, после создания проекта)
    let projsRefresh = 0;
    $: projs = idKontr ? (projsRefresh, fetchprojs(+idKontr)) : Promise.resolve([]);

    $: managersString = selectedManagers.map(m => m.name).join(', ');

    function setDeadline(days) {
        const d = new Date();
        d.setDate(d.getDate() + days);
        deadline = d.toISOString().split('T')[0];
        clearFieldError('deadline');
    }

    function openManager() { managerOpen = true; }

    function confirmManager() {
        managerOpen = false;
        if (document.activeElement) document.activeElement.blur();
    }

    function toggleManager(detail) {
        const exists = selectedManagers.find(m => m.id === detail.id);
        if (exists) {
            selectedManagers = selectedManagers.filter(m => m.id !== detail.id);
        } else {
            selectedManagers = [...selectedManagers, { ...detail }];
        }
        managerOpen = true;
        clearFieldError('manager');
    }

    function removeManager(id) {
        selectedManagers = selectedManagers.filter(m => m.id !== id);
    }

    function clearFieldError(field) {
        if (fieldErrors[field]) fieldErrors = { ...fieldErrors, [field]: '' };
        if (formError) formError = '';
    }

    function onClientCreated(event) {
        const { id, name } = event.detail;
        idKontr = id;
        pendingClient = { idUrllico: id, name };
        showNewClientModal = false;
        showNewProjModal = false;
        clientsPromise = loadClients();
        clearFieldError('client');
        clearFieldError('contact');
    }

    function onProjCreated(event) {
        const { id, name } = event.detail;
        showNewProjModal = false;
        // перезагружаем список проектов клиента и выбираем только что созданный
        projsRefresh++;
        proj = name;
        clearFieldError('proj');
    }




    function onContactCreated(event) {
        const { idKontakt, nameKontakt, telefonKontakt } = event.detail;
        selectedKontakt = { idKontakt, nameKontakt, telefonKontakt };
        kontaktsPromise = network.fetch_proxy(`EXEC getKontakts @idKontr = ${+idKontr}`);
        showNewContactModal = false;
        clearFieldError('contact');
    }

    function focusFirstInvalid(errors) {
        const order = [
            ['vidTask', vidTaskRef],
            ['tipTask', tipTaskRef],
            ['problem', problemRef],
            ['deadline', deadlineInput],
            ['client', clientRef],
            ['manager', managerRef],
            ['contact', contactRef],
            ['proj', projRef]
        ];
        const first = order.find(([key]) => errors[key]);
        if (first?.[1]) {
            first[1].scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                try {
                    first[1].focus?.();
                    first[1].querySelector?.('input, textarea, select, button')?.focus?.();
                } catch (e) {}
            }, 180);
        }
    }

    async function validateForm() {
        const errors = {};
        if (!vidTask) errors.tipTask = 'Выберите вид задачи';

        if (!tipTask) errors.tipTask = 'Выберите тип задачи';
        if (!problem || !problem.trim()) errors.problem = 'Заполните описание задачи';
        if (!deadline) errors.deadline = 'Укажите срок';
        if (!idKontr) errors.client = 'Выберите клиента';
        if (!selectedManagers.length) errors.manager = 'Выберите хотя бы одного менеджера';

        fieldErrors = errors;
        if (Object.keys(errors).length) {
            const firstKey = Object.keys(errors)[0];
            formError = `Не заполнено поле: ${fieldLabels[firstKey]}`;
            focusFirstInvalid(errors);
            return false;
        }
        formError = '';
        return true;
    }

    const sendOrder = async () => {
        if (isSubmitting) return;
        const isValid = await validateForm();
        if (!isValid) return;

        submitSummary = true;
        await new Promise(r => setTimeout(r, 800));
        submitSummary = false;

        isSubmitting = true;
        try {
            let list = await tipTasks;
            let item = list.find(el => el.idTovar === tipTask || el.name === tipTask);

            let payload = {
                tipTask,
                description: '',
                problem: problem.trim(),
                deadline: deadline ? deadline.replace(/-/g, '') : null,
                item: item?.name ?? '',
                user_sklad: +$user.idSklad,
                user_kontr: idKontr,
                user_id: +$user.id,
                userName: managersString,
                idKontakt: selectedKontakt?.idKontakt ?? -1,
                kontaktName: selectedKontakt?.nameKontakt ?? '',
                kontaktTel: selectedKontakt?.telefonKontakt ?? '',
                vidTask,
                proj,
            };

            let result = await network.createTovar(payload);

            network.sendChatMessage(+result.nomDoc, +$user.id, $user.name, problem.trim(), 'text');

            if ($axis) {
                window.top.postMessage('add_item::' + JSON.stringify(payload), '*');
            } else if (result && result.nomDoc) {
                navigate(`/order/${result.nomDoc}/${result.vid ?? 16}`);
            }
        } catch (e) {
            formError = 'Не удалось создать задачу. Попробуйте ещё раз.';
        } finally {
            isSubmitting = false;
        }
    };

    function formatDate(iso) {
        if (!iso) return '';
        const [y, m, d] = iso.split('-');
        return `${d}.${m}.${y}`;
    }
</script>

<TopMenu title="Новая задача">
    <Link to="/dashboard" class="headerButton goBack" slot="left">
        <ion-icon name="chevron-back-outline" role="img" class="md hydrated" aria-label="Назад"></ion-icon>
    </Link>
</TopMenu>

<div id="appCapsule">


    <div class="mt-2 mb-5  sticky-top" >
        <div class="progress-wrap">
            <div class="progress-bar-fill" style="width: {progress}%"></div>
        </div>
        {#if progress < 100}
            <div class="progress-label">Заполнено {progress}%</div>
        {:else}
            <div class="progress-label progress-label--done">Всё заполнено ✓</div>
        {/if}

        {#if formError}
            <div class="form-alert" role="alert">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>{formError}</span>
            </div>
        {/if}
    </div>
    <div class="section mt-2 mb-5 create-page">
        <!-- 1. Клиент -->
        <div class="form-group boxed" bind:this={clientRef}>
            <div class="input-wrapper">
                <label class="form-label">Клиент</label>
                <div class:invalid-shell={fieldErrors.client}>
                    <KontrSelectSearch
                            items={clientList}
                            defaults={$user.idkontr}
                            selectedId={idKontr}
                            on:select={({ detail }) => {
                            idKontr = detail.id ?? $user.idkontr;
                            proj = '';
                            clearFieldError('client');
                            clearFieldError('contact');
                        }}
                    />
                    <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm mt-1"
                            on:click={() => showNewClientModal = true}
                    >
                        + Новый клиент
                    </button>
                    {#if idKontr}
                        <button
                                type="button"
                                class="btn btn-outline-secondary btn-sm mt-1"
                                on:click={() => showNewContactModal = true}
                        >
                            + Новый контакт
                        </button>
                    {/if}
                </div>
                {#if fieldErrors.client}
                    <div class="field-error">{fieldErrors.client}</div>
                {/if}
            </div>
        </div>

        <!-- Контакт (если есть) -->
        {#await kontaktsPromise then kontakts}
            {@const list = toArray(kontakts?.value ?? kontakts).map(({ idKontakt, nameKontakt, telefonKontakt }) => ({ idKontakt, nameKontakt, telefonKontakt }))}
            {#if list.length > 0}
                <div class="form-group boxed fade-in" bind:this={contactRef}>
                    <div class="input-wrapper">
                        <label class="form-label" for="kont">Контакт</label>
                        <select
                                class="form-control form-select {fieldErrors.contact ? 'is-invalid' : ''}"
                                id="kont"
                                on:change={(e) => {
                                selectedKontakt = list.find(k => String(k.idKontakt) === e.target.value) ?? null;
                                clearFieldError('contact');
                            }}
                        >
                            <option value="" disabled selected>Выберите контакт</option>
                            {#each list as item}
                                <option value="{item.idKontakt}">{item.nameKontakt}</option>
                            {/each}
                        </select>
                        {#if fieldErrors.contact}
                            <div class="field-error">{fieldErrors.contact}</div>
                        {/if}
                    </div>
                </div>

                {#if selectedKontakt}
                    <div class="kontakt-card fade-in">
                        <div class="kontakt-row">
                            <span class="kontakt-label">Имя</span>
                            <span class="kontakt-value">{selectedKontakt.nameKontakt}</span>
                        </div>
                        {#if selectedKontakt.telefonKontakt}
                            <div class="kontakt-row">
                                <span class="kontakt-label">Телефон</span>
                                <a class="kontakt-value kontakt-tel" href="tel:{selectedKontakt.telefonKontakt}">
                                    {selectedKontakt.telefonKontakt}
                                </a>
                            </div>
                        {/if}
                    </div>
                {/if}

            {:else if idKontr}
                <div class="form-group boxed">
                    <p class="kontakt-empty">Контакты для этого клиента не найдены</p>
                </div>
            {/if}
        {:catch}
            <div class="form-group boxed">
                <p class="kontakt-empty kontakt-error">Ошибка загрузки контактов</p>
            </div>
        {/await}


        <!-- 2. Тип задачи -->
        <div class="form-group boxed" bind:this={tipTaskRef}>
            <div class="input-wrapper">
                <label class="form-label" for="tipTask">Тип задачи</label>
                <select
                        class="form-control form-select {fieldErrors.tipTask ? 'is-invalid' : ''}"
                        id="tipTask"
                        bind:value={tipTask}
                        on:change={() => clearFieldError('tipTask')}
                >
                    {#await tipTasks}
                        <option selected disabled>Загрузка..</option>
                    {:then list}
                        <option value="" disabled selected>Выберите</option>
                        {#each list as item}
                            <option value="{item.name}">{item.name}</option>
                        {/each}
                    {/await}
                </select>
                {#if fieldErrors.tipTask}
                    <div class="field-error">{fieldErrors.tipTask}</div>
                {/if}
            </div>
        </div>

        <!-- вид задачи -->
        <div class="form-group boxed" bind:this={vidTaskRef}>
            <div class="input-wrapper">
                <label class="form-label">Вид задачи</label>
                <div class="radio-pill-group {fieldErrors.vidTask ? 'invalid-shell' : ''}">
                    <label class="radio-pill">
                        <input type="radio" name="vidTask" value="текущая" bind:group={vidTask}
                               on:change={() => clearFieldError('vidTask')}>
                        <span>текущая</span>
                    </label>
                    <label class="radio-pill">
                        <input type="radio" name="vidTask" value="в проекте" bind:group={vidTask}
                               on:change={() => clearFieldError('vidTask')}>
                        <span>в проекте</span>
                    </label>
                </div>
                {#if fieldErrors.vidTask}
                    <div class="field-error">{fieldErrors.vidTask}</div>
                {/if}


                {#if vidTask === 'в проекте'}
                    <div class="fade-in" bind:this={projRef} style="margin-top: 12px;">
                        <label class="form-label" for="proj">Проект</label>
                        <select
                                class="form-control form-select {fieldErrors.proj ? 'is-invalid' : ''}"
                                id="projs"
                                bind:value={proj}
                                on:change={() => clearFieldError('proj')}
                        >
                            {#await projs}
                                <option selected disabled>Загрузка..</option>
                            {:then list}
                                <option value="" disabled selected>Выберите</option>
                                {#each list as item}
                                    <option value="{item.name}">{item.name}</option>
                                {/each}
                            {/await}
                        </select>
                        {#if fieldErrors.proj}
                            <div class="field-error">{fieldErrors.proj}</div>
                        {/if}

                        <button
                                type="button"
                                class="btn btn-outline-secondary btn-sm mt-1"
                                on:click={() => showNewProjModal = true}
                        >
                            + Новый проект
                        </button>
                    </div>
                {/if}
            </div>
        </div>


        <!-- 3. Описание -->
        <div class="form-group boxed" bind:this={problemRef}>
            <div class="input-wrapper">
                <label class="form-label" for="note">Описание задачи</label>
                <textarea
                        id="note"
                        rows="3"
                        maxlength={MAX_PROBLEM_LENGTH}
                        class="form-control {fieldErrors.problem ? 'is-invalid' : ''}"
                        placeholder="Опишите задачу коротко и по делу"
                        bind:value={problem}
                        on:input={() => clearFieldError('problem')}
                ></textarea>
                <div class="textarea-footer">
                    {#if fieldErrors.problem}
                        <div class="field-error">{fieldErrors.problem}</div>
                    {:else}
                        <span></span>
                    {/if}
                    <span class="char-counter {problem.length > MAX_PROBLEM_LENGTH * 0.9 ? 'char-counter--warn' : ''}">
                        {problem.length}/{MAX_PROBLEM_LENGTH}
                    </span>
                </div>
            </div>
        </div>

        <!-- 4. Срок до -->
        <div class="form-group boxed">
            <div class="input-wrapper">
                <label class="form-label" for="deadline">Срок до</label>

                <div class="date-input-wrap {fieldErrors.deadline ? 'invalid-wrap' : ''}">
                    <ion-icon name="calendar-outline" class="date-icon-left"></ion-icon>
                    <input
                            type="date"
                            id="deadline"
                            class="form-control date-control {fieldErrors.deadline ? 'is-invalid' : ''}"
                            bind:value={deadline}
                            bind:this={deadlineInput}
                            on:input={() => clearFieldError('deadline')}
                    >
                </div>

                <div class="date-shortcuts">
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(1)}>Завтра</button>
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(3)}>+3 дня</button>
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(7)}>+7 дней</button>
                    <button type="button" class="shortcut-btn" on:click={() => setDeadline(14)}>+2 недели</button>
                </div>

                {#if fieldErrors.deadline}
                    <div class="field-error">{fieldErrors.deadline}</div>
                {/if}
            </div>
        </div>

        <!-- 5. Менеджер -->
        <div class="form-group boxed" bind:this={managerRef}>
            <div class="input-wrapper">
                {#if managersLoading}
                    <p>Загрузка...</p>
                {:else}
                    <label class="form-label">Менеджер</label>
                    <div class="manager-select-wrap {fieldErrors.manager ? 'invalid-shell' : ''}">
                        <ManagerSelectSearch
                                items={managerList}
                                defaults={$user.idkontr}
                                selectedIds={selectedManagers.map(m => m.id)}
                                on:select={({ detail }) => toggleManager(detail)}
                                on:focus={openManager}
                        />
                        {#if managerOpen}
                            <button type="button" class="manager-ok-btn" on:click={confirmManager} aria-label="Подтвердить выбор">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </button>
                        {/if}
                    </div>
                    {#if fieldErrors.manager }
                        <div class="field-error">{fieldErrors.manager}</div>
                    {/if}

                    {#if selectedManagers.length > 0}
                        <div class="manager-chips">
                            {#each selectedManagers as mgr}
                            <span class="manager-chip">
                                {mgr.name}
                                <button type="button" class="chip-remove" on:click={() => removeManager(mgr.id)}>✕</button>
                            </span>
                            {/each}
                        </div>
                    {/if}
                {/if}
            </div>
        </div>

        <div class="form-button-group sticky-submit">
            <button
                    on:click={sendOrder}
                    class="btn btn-primary btn-block btn-lg submit-btn"
                    disabled={isSubmitting || submitSummary}
            >
                {#if submitSummary}
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                    {tipTask} · {managersString} · {formatDate(deadline)}
                {:else if isSubmitting}
                    <span class="btn-spinner"></span>
                    Создание...
                {:else}
                    Создать задачу
                {/if}
            </button>
        </div>

    </div>
</div>

{#if showNewClientModal}
    <NewClientModal
            on:created={onClientCreated}
            on:close={() => showNewClientModal = false}
    />
{/if}



{#if showNewProjModal}
    <NewProjModal
            {idKontr}
            on:created={onProjCreated}
            on:close={() => showNewProjModal = false}
    />
{/if}




{#if showNewContactModal}
    <NewContactModal
            idKontr={idKontr}
            on:created={onContactCreated}
            on:close={() => showNewContactModal = false}
    />
{/if}

<style>
    .create-page { padding-bottom: 88px; }
    .progress-wrap { height: 4px; background: #e9ecef; border-radius: 999px; overflow: hidden; margin-bottom: 4px; }
    .progress-bar-fill { height: 100%; background: linear-gradient(90deg, #0b7285, #22c55e); border-radius: 999px; transition: width 0.4s ease; }
    .progress-label { font-size: 11px; color: #9ca3af; text-align: right; margin-bottom: 12px; }
    .progress-label--done { color: #16a34a; font-weight: 600; }
    .form-alert { display: flex; align-items: center; gap: 10px; background: #fff4f4; color: #b42318; border: 1px solid #f0c7c7; border-radius: 12px; padding: 12px 14px; margin-bottom: 14px; font-size: 14px; animation: fadeIn 0.2s ease; }
    .form-alert ion-icon { font-size: 20px; flex-shrink: 0; }
    .form-label { font-size: 12px; font-weight: 600; letter-spacing: 0.02em; color: #6b7280; margin-bottom: 8px; display: block; }
    .form-control, .form-select { border-radius: 12px; border: 1px solid #d8dde3; background: #fff; min-height: 50px; box-shadow: none; transition: border-color .18s ease, box-shadow .18s ease; }
    textarea.form-control { min-height: 96px; padding-top: 12px; resize: vertical; }
    .form-control:focus, .form-select:focus { border-color: #0b7285; box-shadow: 0 0 0 4px rgba(11,114,133,0.08); }
    .is-invalid { border-color: #e5484d !important; background: #fffafa; }
    .invalid-shell :global(input), .invalid-shell :global(.form-control) { border-color: #e5484d !important; }
    .field-error { margin-top: 7px; font-size: 12px; color: #c62828; }
    .textarea-footer { display: flex; justify-content: space-between; align-items: center; margin-top: 6px; }
    .char-counter { font-size: 11px; color: #9ca3af; margin-left: auto; }
    .char-counter--warn { color: #f97316; font-weight: 600; }
    .date-input-wrap { position: relative; display: flex; align-items: center; }
    .date-icon-left { position: absolute; left: 14px; font-size: 18px; color: #0b7285; pointer-events: none; z-index: 2; }
    .date-control { padding-left: 42px !important; cursor: pointer; }
    .date-control::-webkit-calendar-picker-indicator { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; }
    .date-shortcuts { display: flex; gap: 6px; margin-top: 8px; flex-wrap: wrap; }
    .shortcut-btn { padding: 5px 12px; border-radius: 999px; border: 1px solid #d1d5db; background: #fff; font-size: 12px; font-weight: 500; color: #374151; cursor: pointer; transition: all 0.15s ease; }
    .shortcut-btn:hover { background: #e8f4f5; border-color: #0b7285; color: #0b7285; }
    .shortcut-btn:active { transform: scale(0.96); }
    .kontakt-card { background: #f7f8f8; border: 1px solid #e3e7ea; border-radius: 12px; padding: 12px 14px; margin: 0 0 12px 0; display: flex; flex-direction: column; gap: 8px; }
    .kontakt-row { display: flex; align-items: center; gap: 8px; font-size: 14px; }
    .kontakt-label { color: #7a7974; min-width: 64px; font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; }
    .kontakt-value { color: #28251d; font-weight: 500; }
    .kontakt-tel { color: #01696f; text-decoration: none; }
    .kontakt-tel:hover { text-decoration: underline; }
    .kontakt-empty { font-size: 13px; color: #7a7974; padding: 4px 0; margin: 0; }
    .kontakt-error { color: #a12c7b; }
    .manager-select-wrap { position: relative; }
    .manager-select-wrap :global(input) { padding-right: 48px !important; }
    .manager-ok-btn { position: absolute; top: 9px; right: 10px; z-index: 1000; width: 32px; height: 32px; border: none; border-radius: 50%; background: #16a34a; color: #fff; display: inline-flex; align-items: center; justify-content: center; box-shadow: 0 8px 18px rgba(22,163,74,0.22); cursor: pointer; transition: transform .12s ease, background .18s ease; }
    .manager-ok-btn:active { transform: scale(0.95); background: #15803d; }
    .manager-ok-btn ion-icon { font-size: 18px; pointer-events: none; }
    .manager-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
    .manager-chip { display: inline-flex; align-items: center; gap: 4px; background-color: #e8f4f5; color: #01696f; border: 1px solid #b2d8db; border-radius: 999px; padding: 5px 10px 5px 12px; font-size: 13px; font-weight: 500; animation: fadeIn 0.18s ease; }
    .chip-remove { display: inline-flex; align-items: center; justify-content: center; background: none; border: none; cursor: pointer; color: #01696f; font-size: 11px; padding: 0; width: 16px; height: 16px; border-radius: 50%; opacity: 0.7; transition: opacity 0.15s, background 0.15s; }
    .chip-remove:hover { opacity: 1; background-color: rgba(1,105,111,0.15); }
    .sticky-submit { position: sticky; bottom: 12px; z-index: 20; padding-top: 8px; background: linear-gradient(to top, rgba(248,249,250,1), rgba(248,249,250,0.82), rgba(248,249,250,0)); backdrop-filter: blur(6px); }
    .submit-btn { min-height: 52px; border-radius: 14px; font-weight: 600; letter-spacing: 0.01em; box-shadow: 0 10px 24px rgba(1,105,111,0.18); display: inline-flex; align-items: center; justify-content: center; gap: 8px; font-size: 14px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; transition: background 0.2s ease; }
    .submit-btn:disabled { opacity: 0.85; }
    .btn-spinner { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.45); border-top-color: #fff; border-radius: 50%; animation: spin .7s linear infinite; flex-shrink: 0; }
    .fade-in { animation: fadeIn 0.22s ease; }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes spin { to { transform: rotate(360deg); } }

    .radio-pill-group {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    .radio-pill {
        position: relative;
    }

    .radio-pill input {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    .radio-pill span {
        display: inline-block;
        padding: 8px 16px;
        border-radius: 999px;
        border: 1px solid #d1d5db;
        background: #fff;
        font-size: 13px;
        font-weight: 500;
        color: #374151;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .radio-pill input:checked + span {
        background: #0b7285;
        border-color: #0b7285;
        color: #fff;
    }

    .radio-pill input:focus-visible + span {
        box-shadow: 0 0 0 3px rgba(11, 114, 133, 0.25);
    }

</style>